import { render, staticRenderFns } from "./Paimaiqiye.vue?vue&type=template&id=731a4cad&"
import script from "./Paimaiqiye.vue?vue&type=script&lang=js&"
export * from "./Paimaiqiye.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports